'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import { PhotoScanningExecution } from './photo-scanning-execution';

interface PhotoScanningExecutionPageProps {
  batchId: number;
}

export function PhotoScanningExecutionPage({
  batchId
}: PhotoScanningExecutionPageProps) {
  const t = useTranslations('photoScanning');
  const tNav = useTranslations('navigation');

  return (
    // Full-bleed workspace: fill the height (flex-1) and break out of the
    // dashboard shell's `p-6` (negative margins) so the scan UI runs edge to
    // edge instead of sitting in a padded box. The breadcrumb keeps a small
    // inset so it isn't glued to the viewport edge.
    <div className='-mx-6 -mt-6 flex h-[calc(100svh-3.5rem)] flex-col'>
      {/* Breadcrumb */}
      {/* <nav className='text-muted-foreground flex items-center gap-2 px-6 pt-3 pb-2 text-sm'>
        <Link
          href='/dashboard'
          className='hover:text-foreground transition-colors'
        >
          {tNav('breadcrumb.dashboard')}
        </Link>
        <span>·</span>
        <Link
          href='/dashboard/photo-scanning'
          className='hover:text-foreground transition-colors'
        >
          {t('pageTitle')}
        </Link>
        <span>·</span>
        <span className='text-foreground font-medium'>{t('tabExecution')}</span>
      </nav> */}

      <PhotoScanningExecution batchId={batchId} />
    </div>
  );
}
